import React from "react";
import * as xmljs from "xml-js";
import DualEditorConvert from "../components/DualEditorConvert";
import AdSenseAd from "../components/AdSenseAd";

// Helper: recursively unwrap `_text` fields and convert number-like strings
const cleanJson = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    if (typeof obj === 'string' && !isNaN(obj)) {
      return obj.includes('.') ? parseFloat(obj) : parseInt(obj, 10);
    }
    return obj;
  }

  if ('_text' in obj && Object.keys(obj).length === 1) {
    return cleanJson(obj._text);
  }

  const cleaned = {};
  for (const key in obj) {
    cleaned[key] = cleanJson(obj[key]);
  }
  return cleaned;
};

// Convert XML to cleaned JSON string
const convertXmlToJson = (input) => {
  try {
    const rawJson = xmljs.xml2json(input, { compact: true });
    const parsed = JSON.parse(rawJson);
    const cleaned = cleanJson(parsed);
    return JSON.stringify(cleaned, null, 2);
  } catch (err) {
    throw new Error("Invalid XML: " + err.message);
  }
};

const XmlToJson = () => {
  return (
  <div className="max-w-7xl mx-auto px-4 py-6">
  <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-indigo-600 to-blue-600 text-transparent bg-clip-text mb-2">
    XML to JSON Converter
  </h1>
    <DualEditorConvert
    inputLang="xml"
    outputLang="json"
    convertFn={convertXmlToJson}
  />
  <section className="text-gray-700 dark:text-gray-300 text-center max-w-2xl mx-auto mb-6">
    <p className="mb-3">
      Quickly convert your XML data into clean, readable JSON for use in modern web and backend applications. This tool runs entirely in your browser—your data never leaves your device.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Why convert XML to JSON?</h2>
    <ul className="list-disc list-inside text-left mb-3">
      <li>Integrate legacy XML data with modern JavaScript/TypeScript apps.</li>
      <li>Prepare XML for use in REST APIs, NoSQL databases, or config files.</li>
      <li>Facilitate data migration from XML-based to JSON-based systems.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">How to use this tool:</h2>
    <ol className="list-decimal list-inside text-left mb-3">
      <li>Paste or type your XML data into the left editor.</li>
      <li>Click the <b>Convert</b> button.</li>
      <li>Copy the generated JSON from the right editor.</li>
    </ol>
    <h2 className="text-xl font-semibold mt-6 mb-2">Example</h2>
    <div className="bg-gray-100 dark:bg-gray-800 rounded p-3 text-left text-sm mb-3 overflow-x-auto">
      <b>Input XML:</b>
      <pre className="whitespace-pre-wrap">{`<?xml version="1.0" encoding="UTF-8"?>
<person>
  <name>John</name>
  <age>30</age>
  <height>5.9</height>
</person>`}</pre>
      <b>Output JSON:</b>
      <pre className="whitespace-pre-wrap">{`{
  "person": {
    "name": "John",
    "age": 30,
    "height": 5.9
  }
}`}</pre>
    </div>
    <p className="mt-4">Need help? See our <a href="/about" className="text-blue-600 underline">About</a> page or contact us for support.</p>
  </section>

  {/* AdSense Ad - Placed below converter */}
  <AdSenseAd adSlot="9698302360" />
</div>
  );
};

export default XmlToJson;
